import { atom } from 'jotai';

export type MagicEditMode = 'free-edit' | 'remove';

export const magicEditModeAtom = atom<MagicEditMode>('free-edit');
